function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "domk5xsb8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3685",
    style: {
      fill: "#032541"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1504",
    cx: 17,
    cy: 17,
    r: 17,
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 704",
    transform: "translate(5 5)",
    style: {
      clipPath: "url(#domk5xsb8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22196",
    d: "M142.752 41.21h4.442a3.5 3.5 0 0 0 6.793 0h3.919a2.1 2.1 0 0 0 2.195-2.026 2.027 2.027 0 0 0-.993-1.713c-.6-.386-1.594-1.64-1.594-5.861a6.48 6.48 0 0 0-4.6-6.488 1.375 1.375 0 0 0 .026-.314 2.621 2.621 0 0 0-5.226 0 1.276 1.276 0 0 0 .026.314 6.479 6.479 0 0 0-4.6 6.488c0 4.221-.993 5.475-1.594 5.861a2.027 2.027 0 0 0-.993 1.713 2.1 2.1 0 0 0 2.199 2.026zm7.839 1.206a2.066 2.066 0 0 1-1.568-.724h3.135a2.066 2.066 0 0 1-1.568.724zm-.261-18.571a1.042 1.042 0 0 1 1.045.868 7.316 7.316 0 0 0-2.064 0 1 1 0 0 1 1.018-.868zm-7.917 14.809c1.515-.965 2.273-3.328 2.273-7.067A5.218 5.218 0 0 1 149 26.233l.052-.024a4.891 4.891 0 0 1 1.306-.169 4.944 4.944 0 0 1 1.28.169h.026a5.218 5.218 0 0 1 4.311 5.354 13.737 13.737 0 0 0 .732 5.017h-8.988a.726.726 0 1 0 0 1.447h9.85a2.954 2.954 0 0 0 .679.579.646.646 0 0 1 .313.507.623.623 0 0 1-.653.6h-15.13a.623.623 0 0 1-.653-.6.607.607 0 0 1 .287-.458z",
    transform: "translate(-138.309 -21.079)",
    style: {
      fill: "#032541"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22197",
    d: "M231.677 353.8c.052.024.078.048.131.072s.1.024.157.048c.052 0 .1.024.157.024a.741.741 0 0 0 .549-.217.67.67 0 0 0 .235-.507.285.285 0 0 0-.026-.145.323.323 0 0 0-.052-.145c-.026-.048-.052-.072-.078-.121a.431.431 0 0 0-.1-.121l-.1-.1c-.052-.024-.078-.048-.131-.072s-.1-.024-.157-.048a.818.818 0 0 0-.706.193.534.534 0 0 0-.1.121c-.026.048-.052.072-.078.121s-.026.1-.052.145c0 .048-.026.1-.026.145a.635.635 0 0 0 .235.507 1.533 1.533 0 0 1 .157.1z",
    transform: "translate(-224.805 -336.923)",
    style: {
      fill: "#032541"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e11a0c5d2b50555012f78e83080f242e.svg";
export { ForwardRef as ReactComponent };